export default "__VITE_ASSET__35887bfc__"